module.exports = __webpack_public_path__ + "static/media/nicole_ju.7159b452.png";